// import $ from 'jquery'
import Vue from 'vue'
import axios from 'axios'

/**
 * Vue.prototype.$api
 * @type {{loadExamQuestions: BaseApi.loadExamQuestions, loadExams: BaseApi.loadExams, hideIdle: BaseApi.hideIdle, loadParticipants: BaseApi.loadParticipants, archiveStats: BaseApi.archiveStats, setCredentials: BaseApi.setCredentials, checkCredentials: BaseApi.checkCredentials, loadSurveys: BaseApi.loadSurveys, removeUser: BaseApi.removeUser, resetCredentials: BaseApi.resetCredentials, loadQuestions: BaseApi.loadQuestions, loadSystemGroupList: BaseApi.loadSystemGroupList, loadExam: BaseApi.loadExam, boolValueOfExam: BaseApi.boolValueOfExam, downloadExamRankList: BaseApi.downloadExamRankList, loadHistory: BaseApi.loadHistory, calculateExam: BaseApi.calculateExam, downloadExamPointList: BaseApi.downloadExamPointList, loadTests: BaseApi.loadTests, saveSystemGroupRights: BaseApi.saveSystemGroupRights, loadQuestion: BaseApi.loadQuestion, loadParticipantsWithAnswers: BaseApi.loadParticipantsWithAnswers, onGetError: BaseApi.onGetError, loadStats: BaseApi.loadStats, showIdle: BaseApi.showIdle, loadGroup: BaseApi.loadGroup, downloadExamGroupList: BaseApi.downloadExamGroupList, downloadExamNotesAsExcel: BaseApi.downloadExamNotesAsExcel, loadSystemGroupRights: BaseApi.loadSystemGroupRights}}
 */
const BaseApi = {
  participantData: null,
  answerChain: [],
  chainCancelToken: null,
  lastErrors: [],
  saveAnsweAdmin (teilnehmerId, data, fnSuccess, fnError) {
    Vue.prototype.$api.reqIndex = Vue.prototype.$api.reqIndex + 1
    var url = Vue.prototype.$config.HOST_ONLINE + '/v2/system/user/anwer/' + teilnehmerId
    // Vue.prototype.$api.showIdle()
    let cmp = this
    var params = {
      time: new Date().getTime(),
      reqIndex: Vue.prototype.$api.reqIndex,
      token: Vue.prototype.$api.getCredentials().authToken
    }
    axios({
      method: 'post',
      params: params,
      data: JSON.stringify(data),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        try {
          cmp.lastErrors.push('saveAnsweAdmin' + JSON.stringify(error))
        } catch (e) {
          console.error(e)
        }
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  /**
   * @param idKlausur
   * @param idParticipant
   * @param idQuestion
   * @param value
   * @param fnOk
   * @param fnFailed
   */
  saveFreeTextAnswer: function (idKlausur, idParticipant, idQuestion, value, fnSuccess, fnError) {
    Vue.prototype.$api.reqIndex = Vue.prototype.$api.reqIndex + 1
    var data = {
      'value': value
    }
    var url = Vue.prototype.$config.HOST_ONLINE + '/v1/answerPoints/' + idKlausur + '/' + idParticipant + '/' + idQuestion
    Vue.prototype.$api.showIdle()
    let cmp = this
    var params = {
      time: new Date().getTime(),
      reqIndex: Vue.prototype.$api.reqIndex,
      token: Vue.prototype.$api.getCredentials().authToken
    }
    axios({
      method: 'post',
      params: params,
      data: JSON.stringify(data),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        try {
          cmp.lastErrors.push('saveFreeTextAnswer:' + JSON.stringify(error))
        } catch (e) {
          console.error(e)
        }

        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  getCountTodos () {
    if (this.answerChain) {
      return this.answerChain.length
    }
    return 0
  },
  checkTodos () {
    if (this.answerChain) {
      if (this.answerChain.length > 0) {
        this.currentChainIndex = 0
        this.sendRequestFromChain(this.answerChain[this.currentChainIndex])
      }
    }
  },
  sendRequestFromChain (chainData) {
    var params = chainData.params
    let cmp = this
    if (this.chainCancelToken) {
      // console.log('cancel work cause already pending', this.chainCancelToken)
      return
    }

    let ex = function executor (c) {
      // console
    }
    this.chainCancelToken = new axios.CancelToken(ex)
    chainData.data.token = Vue.prototype.$api.getCredentials().authToken
    axios({
      method: 'post',
      url: chainData.url,
      cancelToken: this.chainCancelToken,
      timeout: 15000,
      params: params,
      data: chainData.data
    })
      .then(function (response) {
        // console.log('answer saved', params.reqIndex, response)
        cmp.chainCancelToken = null
        if (response && response.data) {
          Vue.prototype.$eventHub.$emit('requestDone', response.data, chainData)
        }
        cmp.answerChain.shift()
        try {
          window.setTimeout(function () {
            cmp.checkTodos()
          }, 80)
        } catch (eeeee) {
          console.error(eeeee)
        }
      },
      function (error) {
        cmp.chainCancelToken = null
        console.error(error)
        try {
          cmp.lastErrors.push('sendRequestFromChain:' + JSON.stringify(error))
        } catch (e) {
          console.error(e)
        }
        // console.log('answer save failure', params.reqIndex, error)
      })
  },
  hasToDos () {
    if (this.answerChain) {
      if (this.answerChain.length > 0) {
        return true
      }
    }
    return false
  },
  saveAnswer (postData, fnSuccess) {
    var url = Vue.prototype.$config.HOST_ONLINE + '/api/v2/participant/answer'
    Vue.prototype.$api.reqIndex = Vue.prototype.$api.reqIndex + 1
    var params = {
      time: new Date().getTime(),
      reqIndex: Vue.prototype.$api.reqIndex
    }
    this.answerChain.push({
      type: 'answer',
      url: url,
      time: new Date().getTime(),
      reqIndex: Vue.prototype.$api.reqIndex,
      params: params,
      data: postData
    })
    fnSuccess()
  },
  ping (postData, fnSuccess) {
    var url = Vue.prototype.$config.HOST_ONLINE + '/api/v2/participant/ping'
    Vue.prototype.$api.reqIndex = Vue.prototype.$api.reqIndex + 1
    var params = {
      time: new Date().getTime(),
      reqIndex: Vue.prototype.$api.reqIndex
    }
    try {
      if (this.lastErrors.length > 5) {
        postData.errorList = this.lastErrors.slice(0, 5)
      } else {
        postData.errorList = this.lastErrors
      }
    } catch (ea) {
      console.error(ea)
    }

    this.lastErrors = []
    this.answerChain.push({
      url: url,
      type: 'ping',
      time: new Date().getTime(),
      reqIndex: Vue.prototype.$api.reqIndex,
      params: params,
      data: postData
    })
    fnSuccess()
  },
  saveAnswerDirect (postData, fnSuccess, fnError) {
    var url = Vue.prototype.$config.HOST_ONLINE + '/api/v2/participant/answer'
    Vue.prototype.$api.reqIndex = Vue.prototype.$api.reqIndex + 1
    var params = {
      time: new Date().getTime(),
      reqIndex: Vue.prototype.$api.reqIndex,
      token: Vue.prototype.$api.getCredentials().authToken
    }
    let cmp = this
    axios({
      method: 'post',
      url: url,
      params: params,
      data: postData
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        try {
          cmp.lastErrors.push('saveAnswerDirect:' + JSON.stringify(error))
        } catch (e) {
          console.error(e)
        }

        if (!error.response) {
          console.error('network error')
          Vue.prototype.$eventHub.$emit('errorDlg', {
            message: 'Network Error',
            status: -111
          })
        } else {
          if (fnError) {
            fnError(error.response, status, error)
          } else {
            console.error('error')
            console.error(error)
            console.log(status)
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        }
      })
  },
  getUploadedFile (target, fnSuccess, fnError) {
    var url = Vue.prototype.$config.HOST_ONLINE + '/api/v1/free/upload?target=' + target
    let cmp = this
    axios({
      method: 'get',
      params: {},
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }).catch(error => {
        Vue.prototype.$api.hideIdle()
        try {
          cmp.lastErrors.push('getUploadedFile:' + JSON.stringify(error))
        } catch (e) {
          console.error(e)
        }
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  getUploadUrl (target) {
    var url = Vue.prototype.$config.HOST_ONLINE + '/api/v1/free/upload?target=' + target
    return url
  },
  pingDirect (postData, fnSuccess, fnError) {
    var url = Vue.prototype.$config.HOST_ONLINE + '/api/v2/participant/ping'
    Vue.prototype.$api.reqIndex = Vue.prototype.$api.reqIndex + 1
    // Vue.prototype.$api.showIdle()
    let cmp = this
    var params = {
      time: new Date().getTime(),
      reqIndex: Vue.prototype.$api.reqIndex,
      token: Vue.prototype.$api.getCredentials().authToken
    }
    axios({
      method: 'post',
      url: url,
      params: params,
      data: postData
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        try {
          cmp.lastErrors.push('pingDirect:' + JSON.stringify(error))
        } catch (e) {
          console.error(e)
        }
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  setParticipantData: function (groupList, questions) {
    if (questions != null) {
      try {
        for (var gi = 0; gi < groupList.length; gi++) {
          let group = groupList[gi]
          let newList = []
          let last = null
          let parent = null
          if (questions[group.ID_Klausur]) {
            for (var i = 0; i < questions[group.ID_Klausur].length; i++) {
              let question = questions[group.ID_Klausur][i]
              try {
                let config = JSON.parse(question.config)
                if (config.battery && Vue.prototype.$api.stringToBoolean(config.battery)) {
                  if (!parent) {
                    parent = last
                    parent.childs = []
                  }
                } else {
                  parent = null
                  newList.push(question)
                }
              } catch (eee) {
                parent = null
                newList.push(question)
              }
              if (parent) {
                parent.childs.push(question)
              }
              last = question
            }
          }
          questions[group.ID_Klausur] = newList
        }
      } catch (e) {
        console.error(e)
      }
    }
    this.participantData = {
      groupList: groupList,
      questions: questions
    }
    if (window.localStorage) {
      window.localStorage.participantData = JSON.stringify(this.participantData)
    }
  },
  getParticipantData: function () {
    if (!this.participantData) {
      if (window.localStorage) {
        try {
          this.participantData = JSON.parse(window.localStorage.participantData)
          return null
        } catch (e) {

        }
      }
    }
    return this.participantData
  },
  logout (data, fnSuccess, fnError) {
    this.setParticipantData(null, null)
    Vue.prototype.$api.reqIndex = Vue.prototype.$api.reqIndex + 1
    var url = Vue.prototype.$config.HOST_ONLINE + '/api/v2/participant/logout'
    let cmp = this
    data.token = Vue.prototype.$api.getCredentials().authToken
    var params = {
      time: new Date().getTime(),
      reqIndex: Vue.prototype.$api.reqIndex
    }
    axios({
      method: 'post',
      params: params,
      data: data,
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        try {
          cmp.lastErrors.push('logout:' + JSON.stringify(error))
        } catch (e) {
          console.error(e)
        }
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  }
}
export default BaseApi



// WEBPACK FOOTER //
// ./src/apiParticipant.js